import React, { useState } from "react";
import Staff1 from "../../assets/images/staff/staff1.webp";
import Staff2 from "../../assets/images/staff/staff2.webp";
import Staff6 from "../../assets/images/staff/staff6.jpg";
import Staff4 from "../../assets/images/staff/staff4.webp";
import Staff5 from "../../assets/images/staff/staff5.webp";
import Video1 from "../../assets/videos/v1.mp4";
import Video2 from "../../assets/videos/v2.mp4";
import Video3 from "../../assets/videos/v3.mp4";
import Video4 from "../../assets/videos/v4.mp4";
import Video6 from "../../assets/videos/v6.mp4";
import { useTranslation } from "react-i18next";

const TeamSlider = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(2);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const teamMembers = [
    { id: 1, img: Staff4, name: "Member 1", video: Video1 },
    { id: 2, img: Staff2, name: "Member 2", video: Video2 },
    { id: 3, img: Staff6, name: "Member 6", video: Video6 },
    { id: 4, img: Staff5, name: "Member 4", video: Video4 },
    { id: 5, img: Staff1, name: "Member 3", video: Video3 },
  ];

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? teamMembers.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === teamMembers.length - 1 ? 0 : prev + 1));
  };

  const getSlidePosition = (index) => {
    const diff =
      (index - currentIndex + teamMembers.length) % teamMembers.length;

    switch (diff) {
      case 0:
        return "translate-y-0 translate-x-0 scale-110 z-30 opacity-100";
      case 1:
        return "translate-y-[-20px] md:translate-y-[-40px] translate-x-[90px] md:translate-x-[180px] scale-100 z-20 opacity-90";
      case 2:
        return "translate-y-[-40px] md:translate-y-[-80px] translate-x-[180px] md:translate-x-[360px] scale-90 z-10 opacity-80";
      case teamMembers.length - 1:
        return "translate-y-[-20px] md:translate-y-[-40px] -translate-x-[90px] md:-translate-x-[180px] scale-100 z-20 opacity-90";
      case teamMembers.length - 2:
        return "translate-y-[-40px] md:translate-y-[-80px] -translate-x-[180px] md:-translate-x-[360px] scale-90 z-10 opacity-80";
      default:
        return "hidden";
    }
  };

  const handleMemberClick = (videoSrc) => {
    setSelectedVideo(videoSrc);
  };

  const closeVideo = () => {
    setSelectedVideo(null);
  };

  return (
    <div
      className="flex flex-col items-center w-full overflow-hidden relative pb-6 font-roboto"
      style={{
        background: "transparent",
      }}
    >
      <h2
        className="text-[20px] md:text-[24px] lg:text-[30px] text-[#212529] font-roboto leading-tight mb-6 px-6 text-center"
        style={{
          background:
            "linear-gradient(to right, rgba(244, 239, 234, 0), rgba(244, 239, 229, 1), rgba(244, 239, 234, 0))",
          padding: "12px 20px",
          borderRadius: "50px",
        }}
      >
        {t("sliderTitle")}
      </h2>

      {/* Slider Elemanları */}
      <div className="flex justify-center items-center relative w-full mt-4 h-[210px] md:h-[280px] lg:h-[360px]">
        {teamMembers.map((member, index) => (
          <div
            key={member.id}
            className={`group absolute transition-transform duration-500 ease-in-out ${getSlidePosition(
              index
            )} w-[130px] h-[175px] md:w-[185px] md:h-[255px] lg:w-[220px] lg:h-[295px] rounded-[10px] md:rounded-[15px] lg:rounded-[20px] shadow-lg bg-[#ffffff] overflow-hidden cursor-pointer`}
            onClick={() => handleMemberClick(member.video)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
                event.preventDefault();
                handleMemberClick(member.video);
              }
            }}
          >
            <img
              src={member.img}
              alt={`team member ${member.id}`}
              className="w-full h-full object-cover rounded-[10px] md:rounded-[15px] lg:rounded-[20px] group-hover:scale-105 transition-transform duration-500"
            />
            {/* Alt gradient şerit */}
            <div className="absolute bottom-0 left-0 right-0 h-14 md:h-16 bg-gradient-to-t from-black/60 to-transparent rounded-b-[10px] md:rounded-b-[15px] lg:rounded-b-[20px]" />
            {/* Play Butonu */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 pointer-events-none">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white/90 rounded-full flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#625480" className="w-3.5 h-3.5 md:w-4 md:h-4 ml-0.5">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Ok Butonları — kartların altında, ortada */}
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          onClick={prevSlide}
          className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-[#625480] flex items-center justify-center hover:bg-[#625480] group transition-colors duration-200"
          aria-label="Previous"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#625480" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 group-hover:stroke-white transition-colors duration-200">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <button
          onClick={nextSlide}
          className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-[#625480] flex items-center justify-center hover:bg-[#625480] group transition-colors duration-200"
          aria-label="Next"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#625480" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 group-hover:stroke-white transition-colors duration-200">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      {selectedVideo && (
        <div
          className="fixed inset-0 z-[999] bg-black bg-opacity-70 flex items-center justify-center p-4"
          onClick={closeVideo}
        >
          <div
            className="relative w-full max-w-[90vw] md:max-w-3xl lg:max-w-4xl"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              aria-label="Close video"
              className="absolute top-2 right-2 bg-white text-[#625480] rounded-full w-10 h-10 text-2xl flex items-center justify-center shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#625480]"
              onClick={closeVideo}
            >
              &times;
            </button>
            <div
              className="relative w-full overflow-hidden rounded-lg shadow-xl bg-black"
              style={{ aspectRatio: "16 / 9", maxHeight: "80vh" }}
            >
              <video
                src={selectedVideo}
                controls
                autoPlay
                className="absolute inset-0 w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamSlider;
